import api from '../../../services/api'

const totalQuantityPath = (sessionalPlanId, totalQuantityId) => (
  `/sessional-plans/${sessionalPlanId}/total-quantities/${totalQuantityId}`
)

const weeklyQuantityPath = (sessionalPlanId, totalQuantityId, weeklyQuantityId) => (
  `${totalQuantityPath(sessionalPlanId, totalQuantityId)}/weekly-quantities/${weeklyQuantityId}`
)

const dailyQuantityPath = (
  sessionalPlanId,
  totalQuantityId,
  weeklyQuantityId,
  dailyQuantityId,
) => `${weeklyQuantityPath(
  sessionalPlanId,
  totalQuantityId,
  weeklyQuantityId,
)}/daily-quantities/${dailyQuantityId}`

export const getSessionalPlans = () => api.get('/sessional-plans')
export const getSessionalPlan = (sessionalPlanId) => api.get(`/sessional-plans/${sessionalPlanId}`)
export const createSessionalPlan = (payload) => api.post('/sessional-plans', payload)
export const updateSessionalPlan = (sessionalPlanId, payload) => api.put(`/sessional-plans/${sessionalPlanId}`, payload)
export const deleteSessionalPlan = (sessionalPlanId) => api.delete(`/sessional-plans/${sessionalPlanId}`)

export const getWeeklyPlan = (sessionalPlanId, weekNum) => api.get(
  `/sessional-plans/${sessionalPlanId}/weekly-plans/${weekNum}`,
)
export const getDailyPlan = (date) => api.get(`/sessional-plans/daily-plans/${date}`)

export const getTotalQuantity = (sessionalPlanId, totalQuantityId) => api.get(
  totalQuantityPath(sessionalPlanId, totalQuantityId),
)
export const createTotalQuantity = (sessionalPlanId, payload) => api.post(
  `/sessional-plans/${sessionalPlanId}/total-quantities`,
  payload,
)
export const updateTotalQuantity = (sessionalPlanId, totalQuantityId, payload) => api.put(
  totalQuantityPath(sessionalPlanId, totalQuantityId),
  payload,
)
export const deleteTotalQuantity = (sessionalPlanId, totalQuantityId) => api.delete(
  totalQuantityPath(sessionalPlanId, totalQuantityId),
)

export const getWeeklyQuantity = (sessionalPlanId, totalQuantityId, weeklyQuantityId) => api.get(
  weeklyQuantityPath(sessionalPlanId, totalQuantityId, weeklyQuantityId),
)
export const updateWeeklyQuantity = (sessionalPlanId, totalQuantityId, weeklyQuantityId, payload) => api.patch(
  weeklyQuantityPath(sessionalPlanId, totalQuantityId, weeklyQuantityId),
  payload,
)
export const delayWeeklyQuantity = (sessionalPlanId, totalQuantityId, weeklyQuantityId, payload) => api.patch(
  `${weeklyQuantityPath(sessionalPlanId, totalQuantityId, weeklyQuantityId)}/delays`,
  payload,
)

export const updateDailyQuantity = (
  sessionalPlanId,
  totalQuantityId,
  weeklyQuantityId,
  dailyQuantityId,
  payload,
) => api.patch(dailyQuantityPath(
  sessionalPlanId,
  totalQuantityId,
  weeklyQuantityId,
  dailyQuantityId,
), payload)

export const updateDailyCompletedQuantity = (
  sessionalPlanId,
  totalQuantityId,
  weeklyQuantityId,
  dailyQuantityId,
  payload,
) => api.patch(`${dailyQuantityPath(
  sessionalPlanId,
  totalQuantityId,
  weeklyQuantityId,
  dailyQuantityId,
)}/completed-quantities`, payload)

export const delayDailyQuantity = (
  sessionalPlanId,
  totalQuantityId,
  weeklyQuantityId,
  dailyQuantityId,
  payload,
) => api.patch(`${dailyQuantityPath(
  sessionalPlanId,
  totalQuantityId,
  weeklyQuantityId,
  dailyQuantityId,
)}/delays`, payload)

export const getCompletionRateMetrics = (params) => api.get(
  '/sessional-plans/analytics/completion-rates/metrics',
  { params },
)
export const getCompletionRateSeries = (params) => api.get(
  '/sessional-plans/analytics/completion-rates/series',
  { params },
)
